import cn from "classnames";
import { Select } from "components/shared/select";
import { themeContainer } from "helpers/redux";
import compact from "lodash/compact";
import debounce from "lodash/debounce";
import React from "react";
import ReactSelect, { components } from "react-select";

const CarGroup = (props) => {
    const {
        children,
        className,
        cx,
        getStyles,
        Heading,
        headingProps,
        innerProps,
        label,
        theme,
        selectProps,
        data,
        getClassNames,
    } = props;
    return (
        <div style={getStyles("group", props)} className={cx({ group: true }, className)} {...innerProps}>
            <div
                className={cn("select-group", {
                    "select-group--selected":
                        Array.isArray(selectProps.value) && selectProps.value.includes(data.value),
                    "select-group--hoverable": data.value !== 0,
                    "select-group--disabled": data.value === 0,
                })}
                onClick={() => {
                    if (data.value === 0) {
                        return;
                    }
                    const current = selectProps.dataIndex === "transportColumnId" ? selectProps.value || [] : [];
                    const next = current.includes(data.value)
                        ? current.filter((v) => v !== data.value)
                        : [...current, data.value];
                    props.onChange({ name: "transportColumn", value: next.length ? next : null });
                }}
            >
                <Heading
                    {...headingProps}
                    selectProps={selectProps}
                    theme={theme}
                    getStyles={getStyles}
                    cx={cx}
                    getClassNames={getClassNames}
                >
                    {label}
                </Heading>
            </div>
            <div>{children}</div>
        </div>
    );
};

const CarValueContainer = (props) => {
    const { children, options, selectProps, hasValue, getValue } = props;
    if (selectProps.dataIndex === "transportColumnId") {
        const selected = options.filter((item) => (selectProps.value || []).includes(item.value));
        if (selected.length > 0) {
            const label = selected.length === 1 ? selected[0].label : `Колонна (${selected.length})`;
            return (
                <components.ValueContainer {...props}>
                    {!props.selectProps.inputValue && (
                        <components.SingleValue {...props}>{label}</components.SingleValue>
                    )}
                    {children[children.length - 1]}
                </components.ValueContainer>
            );
        }
    }
    if (!hasValue) {
        return <components.ValueContainer {...props} />;
    }
    const length = getValue().length;
    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && (
                <components.SingleValue {...props}>
                    {length === 1 ? getValue()[0].label : `Выбрано (${length})`}
                </components.SingleValue>
            )}
            {children[children.length - 1]}
        </components.ValueContainer>
    );
};

const Option = (props) => (
    <div className="select-option">
        <components.Option {...props}>{props.label}</components.Option>
    </div>
);

const initPag = { start: 0, filters: [] };

export class CarSelect extends Select {
    constructor(props) {
        super(props);
        this.debouncedLoadItems = debounce(this.debouncedLoadItems, 1000);
    }

    UNSAFE_componentWillMount() {
        this.setState({
            ...this.state,
            params: initPag,
            isSelect: true,
            isAsyncSelect: !!this.props.url,
            isLoading: false,
            inputValue: "",
            options: [],
            optionsLoaded: false,
            dataIndex: this.props.dataIndex,
        });
        this.validate(this.props.value, { isValid: true });
    }

    UNSAFE_componentWillReceiveProps() {
        return undefined;
    }

    setValue = (newValue) => {
        const { inputProps, onChange, isMulti } = this.props;
        this.validate(newValue);
        const value = isMulti ? (newValue || []).map((option) => option.value) : newValue ? newValue.value : null;
        this.setState({ dataIndex: "id" });
        onChange([
            { name: "transportColumn", value: null },
            { name: inputProps.name, value: compact(value), option: newValue && newValue.option },
        ]);
    };

    setTransportColumn = (data) => {
        const { onChange, inputProps } = this.props;
        this.setState({ dataIndex: "transportColumnId" });
        onChange([{ name: inputProps.name, value: null }, data]);
    };

    getValueOption = (options = [], value) => {
        if (!value || this.state.dataIndex === "transportColumnId") {
            return null;
        }
        const valueOptions = options.filter((car) =>
            Array.isArray(value) ? value.includes(car.id) : value === car.id,
        );
        return valueOptions.length > 0
            ? valueOptions.map((car) => ({ value: car.id, label: car.number, formatted: true, option: car }))
            : { label: "", value };
    };

    checkValueExistsInOptions = () => null;

    debouncedLoadItems = () => {
        const { inputValue } = this.state;
        const filters = [{ dataIndex: ["number", "transportColumnName"], value: inputValue }];
        const params = { ...initPag, filters };
        this.getItems(params).then((data) => this.resHandler(this.state.options.concat(data)));
    };

    formatData = (data) => {
        const uniq = {};
        return data.filter(({ id }) => !uniq[id] && (uniq[id] = true));
    };

    filterOptions = (options) =>
        Object.values(
            options.reduce((acc, car) => {
                if (!acc[car.transportColumnId]) {
                    acc[car.transportColumnId] = {
                        label: car.transportColumnId ? car.transportColumnName : "Без колонны",
                        options: [],
                        value: car.transportColumnId ? parseInt(car.transportColumnId) : 0,
                    };
                }
                acc[car.transportColumnId].options.push({
                    value: car.id,
                    label: car.number,
                    formatted: true,
                    option: car,
                });
                return acc;
            }, {}),
        );

    renderField = () => {
        const { values } = this.props;
        const props = {
            ...this.defaultSelectOptions(),
            dataIndex: this.state.dataIndex,
            value:
                this.state.dataIndex === "transportColumnId"
                    ? (Array.isArray(values.transportColumn)
                          ? values.transportColumn
                          : [values.transportColumn]
                      ).filter(Boolean)
                    : this.getValueOption(this.state.options, values.car),
            components: {
                Option,
                ValueContainer: CarValueContainer,
                Group: (props) => <CarGroup {...props} onChange={this.setTransportColumn} />,
            },
            filterOption: (value, search) => {
                if (!value.label) {
                    return false;
                } else {
                    return search
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (item) =>
                                value.label.toLowerCase().indexOf(item) > -1 ||
                                (value.data.option.transportColumnName || "").toLowerCase().indexOf(item) > -1,
                        );
                }
            },
        };
        return <ReactSelect {...props} />;
    };
}

export default themeContainer(CarSelect);
